import React from 'react';
import { Link } from 'react-router-dom';

const Hero = ({ settings }) => {
  const subtext = settings?.hero_subtext || 'Picadas premium artesanales armadas a tu medida con productos frescos de campo';

  return (
    <section className="relative min-h-[70vh] flex items-center justify-center bg-gradient-to-b from-[#1a0f0a] to-[#2C1810]">
      <div className="absolute inset-0 bg-black/30"></div>
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-[#EFE1C4] tracking-wider mb-6">
          PICADAS DEL CAMPO
        </h1>
        <p className="text-lg md:text-xl text-[#D4A574] mb-4 font-light tracking-wide">
          Armá tu picada a medida
        </p>
        <p className="text-base md:text-lg text-[#b8a080] mb-8 max-w-2xl mx-auto leading-relaxed">
          {subtext}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/productos" className="bg-[#D4A574] text-[#1a0f0a] px-8 py-3 rounded-lg font-semibold hover:bg-[#c49564] transition-colors text-lg">
            Armá tu picada
          </Link>
          <Link to="/presentacion" className="border-2 border-[#D4A574] text-[#D4A574] px-8 py-3 rounded-lg font-semibold hover:bg-[#D4A574] hover:text-[#1a0f0a] transition-colors text-lg">
            Nuestras Picadas
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
